export const sharedBodyClass = 'pb-4 w-2/3';
export const sharedLabelClass = 'w-1/2';
export const sharedValueClass = 'item-start w-full';
